const common = {
    'common.sure': 'Conferma',
    'common.save': 'Salva',
    'common.cancel': 'Annulla',
    'common.loading': 'Caricamento in corso...',
    'common.loading.noMore': 'Non più~',
    'common.loading.loading1': 'Caricamento in corso',
    'common.success': 'Successo',
    'common.fail': 'Fallimento',
    'common.unKnowError': 'Anomalia ignota',
    'common.unitDayOdd': 'Giorno',
    'common.unitDayPlural': 'Giorni',
    'common.unitMonthOdd': 'Mese',
    'common.unitMonthPlural': 'Mesi',
    'common.infiniteAct': 'il primo illimitato !',
    'common.label': 'Promozione in arrivo',
    'common.404': 'Ops. La pagina richiesta non è stata trovata!'
}
const language = {
    'lang.chinese': 'Cinese',
    'lang.english': 'Inglese',
    'lang.germany': 'Tedesco',
    'lang.spanish': 'Spagnolo',
    'lang.french': 'Francese',
    'lang.italian': 'Italiano',
    'lang.portuguese': 'Portoghese',
}
// 登录页
const login = {
    'login.loginText': 'Accedi',
    'login.input.email': 'Email(LenovoID)',
    'login.input.password': 'Password',
    'login.tip.noAccount': 'Non hai ancora un account?',
    'login.tip.toRegister': 'Vai a registrarti',
    'login.tip.forget': 'Dimentica la password',
    'login.check.noInfo': 'Errore di Email o password',
    'login.failed': 'Accesso non riuscito',
    'login.banner.flow': 'Offerta imperdibile! Registrati ora e goditi 1GB di dati gratuiti per 6 mesi*',
    'login.banner.VFflow': 'Offerta imperdibile! Registrati ora e goditi 5GB di dati gratuiti per 3 mesi*',
    'login.banner.coming': 'con una sorpresa per il primo mese:',
    'login.banner.size': 'dati illimitati!'
    // 'login.terms': 'Si prega di rivedere i termini e le condizioni' 原文没有这句
}
// 注册页面
const register = {
    'register.registerText': 'Registrati',
    'register.input.firstName': 'First Name',
    'register.check.noFirstNameField': 'Please input First Name',
    'register.input.lastName': 'Last Name',
    'register.check.noLastNameField': 'Please input Last Name',
    'register.input.email': 'Email',
    'register.input.imgCode': 'Codice di verifica dell\'immagine',
    'register.input.verifyCode': 'Codice di verifica',
    'register.input.password': 'Password',
    'register.input.rePassword': 'Conferma password',
    'register.input.alRegister': 'Già registrato',
    'register.input.toLogin': 'Vai a Accendere',
    'register.input.termsOfService': 'termini di utilizzo',
    'register.input.privacyStatement': 'l\'informativa sulla privacy',
    'register.tip': 'Creando un account, accetta i {termsOfService} e {privacyStatement}.',
    'register.tipForTablet': 'Con la creazione dell’account, avete letto e accettato le <a1>descrizioni del piano di precaricamento dei dati</a1>, <a2>i termini e le condizioni</a2> di Lenovo Connect, <a3>i termini e le condizioni</a3> di HUE, <a4>la politica in materia di Privacy</a4> di Lenovo Connect, e <a5>la politica in materia di Privacy</a5> di HUE.',
    'register.sendMsg.text': 'Ottieni il codice di verifica',
    'register.sendMsg.reSend': 'Invio di nuovo',
    'register.sendMsg.sendSuccess': 'Invio riuscito',
    'register.sendMsg.sendFailed': 'Invio non riuscito',
    'register.check.noEmailField': 'Inserisci la tua email',
    'register.check.noImageCodeField': 'Inserisci il codice di verifica dell\'immagine',
    'register.check.noVerifyField': 'Inserisci il codice di verifica e-mail',
    'register.check.noPasswdField': 'Inserisci la password',
    'register.check.noConfirmPasswd': 'Conferma la tua password',
    'register.check.errorEmail': 'Errore di email ',
    'register.check.errorImageCode': 'Errore di codice di verifica dell\'immagine',
    'register.check.errorVerifyCode': 'Errore di codice di verifica',
    'register.check.errorPasswd': 'Errore di password',
    'register.check.errorTwoPasswd': 'Password incoerente',
    'register.success': 'Registrazione riuscita',
}
// 首页
const home = {
    'home.header.upload': 'Carica',
    'home.header.iccid': 'Codice ICCID',
    'home.flowUse.title': 'Piano dati corrente',
    'home.flowUse.status.title': 'Stato di utilizzo',
    'home.flowUse.status.used': 'Utilizzato',
    'home.flowUse.status.remaining': 'Rimanente',
    'home.flowUse.dataPlan.key': 'Nome di piano dati',
    'home.flowUse.validity.key': 'Validità',
    'home.flowUse.note.key': 'Nota',
    'home.flowUse.note': 'Nota',
    'home.flowUse.leftDay': '{day} {unit} rimanenti',
    'home.flowUse.currentDataPlan.title': 'Mio piano dati',
    'home.flowUse.currentDataPlan.titleHue': 'Il mio piano di servizi di connettività',
    'home.flowUse.outDate': 'Il piano dati è scaduto.',
    'home.flowUse.lock': 'La scheda SIM è bloccata.',
    'home.flowUse.noDataPlan': 'Dati inutilizzati',
    'home.flowUse.status.unlimited': 'illimitato',
    'home.area.intro.title': 'Ricarica piani dati',
    'home.area.intro.titleHue': 'Riempire',
    'home.area.intro.content': 'I nostri piani possono coprire tutti i paesi <cta>dell\'UE</cta> (Austria, Belgio, Bulgaria, Croazia, Cipro, Repubblica Ceca, Danimarca, Estonia, Finlandia, Francia, Germania, Grecia, Ungheria, Irlanda, Italia, Lettonia, Lituania, Lussemburgo, Malta, Paesi Bassi, Polonia , Portogallo, Romania, Slovacchia, Slovenia, Spagna e Svezia), <cta>e Islanda, Norvegia, Svizzera, Regno Unito e Stati Uniti d\'America,</cta>.',
    'home.area.intro.contentHUE': 'I nostri piani possono coprire tutti i paesi <cta>dell\'UE</cta> (Austria, Belgio, Bulgaria, Croazia, Cipro, Repubblica Ceca, Danimarca, Estonia, Finlandia, Francia, Germania, Grecia, Ungheria, Irlanda, Italia, Lettonia, Lituania, Lussemburgo, Malta, Paesi Bassi, Polonia , Portogallo, Romania, Slovacchia, Slovenia, Spagna e Svezia), <cta>e Islanda, Norvegia, Svizzera, Regno Unito,</cta>attiva entrambi i dati mobili e il roaming (senza costi di roaming aggiuntivi).',
    'home.area.intro.vatIntro': 'I prezzi includono l\'IVA se applicabile.',
    'home.area.intro.suggest': 'Suggerire',
    'home.area.switch.title': 'Regione:',
    'home.active.title': 'Attiva il mio piano dati',
    'home.active.intro': 'Il piano dati precaricato "{packageContent}" deve essere attivato entro 90 giorni dall\'acquisto della scheda SIM Lenovo Connect. La validità del piano dati è di {timeLength} a partire dall\'attivazione.',
    'home.active.agree': 'Sì, ho letto e accettato la <a>descrizione del piano dati precaricato</a>, i <a1>termini e le condizioni</a1> e <a2>l\'informativa sulla privacy</a2>. Lenovo Connect Powered by Truphone.',
    'home.active.agreeForTablet': 'Sì, ho letto e accettato la <a>descrizione del piano dati precaricato</a>, i <a1>termini e le condizioni</a1> e <a2>l\'informativa sulla privacy</a2>.',
    'home.active.btnText': 'Attiva ora',
    'home.active.failed': 'Attivo non riuscito!',
    'home.active.success': 'Attivo riuscito',
    'home.active.success.btn': 'Capito',
    'home.active.detail.title': 'Descrizione del piano dati',
    'home.active.detail.faq': "Se hai qualsiasi questione, consulta il <a>l'Assistenza Clienti</a>.",
}
const suggest = {
    'suggest.title': 'Scatola dei suggerimenti',
    'suggest.toast': 'Inserisci il contenuto',
    'suggest.success': 'Riuscito',
    'suggest.suggestions': 'Condividi i tuoi suggerimenti o domande con noi',
    'suggest.submit': 'Invia',
    'suggest.information': 'Informazione',
    'suggest.submission': 'La mia sottomissione',
    'suggest.noMore': 'Niente più dati',
    'suggest.uploadImg': "La dimensione dell'immagine non deve superare 5M",
}
// 我的页面
const me = {
    'me.signOut': 'Esci',
    'me.nav.device': 'Dispositivi personali',
    'me.nav.package': 'Piani dati personali',
    'me.nav.order': 'Ordini',
    'me.nav.accountInfo': 'Account',
    'me.nav.FAQ': 'FAQ',
    'me.nav.contactUs': 'Contattaci',
    'me.signOut.alert.title': 'Esci',
    'me.signOut.alert.content': 'Sei sicuro di voler uscire?'
}
// 套餐卡片
const packageCard = {
    'package.validDate': 'Validità di {timeLength} {dateUnit}',
    'package.validTo': 'Valido fino al {date} UTC',
    'package.orderBtnText': 'Abbono ora',
    'package.extend.title': 'Piano dati base',
    'package.expand.title': 'Espandi il piano dati',
    'package.extend.titleHue': 'Abbonati a un piano di servizi di connettività mensile',
    'package.expand.titleHue': 'Aggiungi un piano di servizi di connettività aggiuntivo',
    'package.expand.add': 'Aggiungi',
}
// 套餐详情
const packageDetail = {
    'packageDetail.privacy': 'Sì, ho letto e accettato le istruzioni, i <a>termini e le condizioni</a> e <b>l\'informativa sulla privacy</b>.',
    'packageDetail.privacyForTablet': 'Sì, ho letto e accettato le istruzioni, i <a>termini e le condizioni</a> e <b>l\'informativa sulla privacy</b>.',
    'packageDetail.description': 'Descrizione del piano dati',
    'packageDetail.expansionPackage.title': 'Espandi il piano dati corrente',
    'packageDetail.payBtn.text': 'Paga ora',
}
// 地址
const billAddress = {
    'billAddress.history.title': 'Indirizzo di fatturazione storico',
    'billAddress.fieldWrap.title': 'Inserisci il tuo indirizzo di fatturazione',
    'billAddress.btn.continue': 'Continua',
    'billAddress.btn.cancel': 'Cancella',
    'billAddress.field.firstName': 'Nome',
    'billAddress.field.lastName': 'Cognome',
    'billAddress.field.email': 'Email',
    'billAddress.field.street': 'Via',
    'billAddress.field.city': 'Città',
    'billAddress.field.state': 'Provincia',
    'billAddress.tips.payment': 'come pagare',
    'billAddress.tips.newCard': 'nuova scheda',
    'billAddress.tips.oldCard': 'vecchia scheda',
    'billAddress.field.postCode': 'CAP',
    'billAddress.field.country': 'Stato',
    'billAddress.field.firstNameError': 'La colonna del /i nome / i non può essere vuota',
    'billAddress.field.lastNameError': 'La colonna del cognome non può essere vuota',
    'billAddress.field.emailError': 'La colonna dell\'email non può essere vuota',
    'billAddress.field.emailFormatError': 'Errore nel formato dell\'email',
    'billAddress.field.streetError': 'La colonna della via non può essere vuota',
    'billAddress.field.cityError': 'La colonna della città non può essere vuota',
    'billAddress.field.stateError': 'La colonna della provincia non può essere vuota',
    'billAddress.field.postCodeError': 'La colonna del CAP non può essere vuota',
    'billAddress.field.countryError': 'La colonna del paese non può essere vuota',
}
// 订单
const order = {
    'order.subType.1': 'Attiva',
    'order.subType.2': 'Ordina',
    'order.subType.4': 'Riscatta',
    'order.subType.5': 'Regalo',
    'order.subType.6': 'Ordine dell\'impresa',
    'order.subType.7': 'Prova',
    'order.subType.8': 'Aggiornamento',
    'order.subType.9': 'Data Plus',
    'order.subType.systemOrder': 'Ordine del sistema',
    'order.item.orderNum': 'N. di ordine',
    'order.item.content': 'Dettagli',
    'order.item.orderType': 'Tipo dell\'ordine',
    'order.item.validity': 'Validità',
    'order.item.subTotal': 'Totale parziale',
    'order.item.vat': 'IVA',
    'order.item.totalFee': 'Totale',
    'order.noInfo.message': 'Nessun piano ordinato!',
    'order.noInfo.btnText': 'Torna alla Homepage'
}
// 支付结果页
const payResult = {
    'pay.success': 'Pagamento risuscito',
    'pay.fail': 'Pagamento non riuscito',
    'pay.checkOrder': 'Controlla ordini',
    'pay.back': 'Ritorna',
    'pay.continue': 'Continua a ordinare',
}
// 我的设备页面
const device = {
    'device.switch': 'Cambia dispositivo',
    'device.status.current': 'Corrente',
    'device.status.available': 'Disponibile',
    'device.switch.alert.title': 'Cambia dispositivo',
    'device.switch.alert.content': 'Sei sicuro di passare a questo dispositivo?',
    'device.noInfo.message': 'Nessun dispositivo vincolato',
    'device.noInfo.btnText': 'Carica il codice ICCID',
    'device.edit.prompt.message': 'Inserisci il tuo soprannome',
    'device.edit.check.none': 'Soprannome non può essere vuoto',
}
// 我的套餐
const myDataPlan = {
    'myDataPlan.tabbar.available': 'Disponibile',
    'myDataPlan.tabbar.expired': 'Scaduto',
    'myDataPlan.noAvailablePlan': 'Nessun piano disponibile al momento',
    'myDataPlan.noExpiredPlan': 'Nessun piano scaduto al momento',
}
// 账号信息
const accountInfo = {
    'account.errorNickname': 'La lunghezza del soprannome deve essere di 4-20 caratteri.',
    'account.account.fieldTitle': 'Account',
    'account.nickName.fieldTitle': 'Soprannome',
    'account.nickName.character': '4 - 20 caratteri, inclusi inglese e cinese, numeri e "-".',
}
// FAQ页面
const FAQ = {
    'faq.question.1': 'Posso effettuare la chiamata o inviare SMS?',
    'faq.question.2': 'Come posso acquistare un piano dati e controllare il record del mio ordine?',
    'faq.question.3': 'Quali sono le regole per ordinare i dati?',
    'faq.question.4': 'Quali metodi di pagamento posso utilizzare?',
    'faq.question.5': 'Come disattivo il mio piano dati se non voglio utilizzarlo?',
    'faq.question.6': 'Ho ordinato con successo un piano dati, perché non posso utilizzarlo?',
    'faq.question.7': 'Cosa succede se non riesco ad accedere a Internet?',
    'faq.question.8': 'Quali paesi può coprire il piano dati?',
    'faq.question.9': "Come posso contattare l'Assistenza Clienti Lenovo?",
    'faq.question.10': 'Come posso richiedere una fattura per il mio ordine?',
    'faq.question.11': 'Come sostituire una scheda SIM?',
    'faq.question.12': 'È gratuito sostituire una scheda SIM?',
    'faq.question.13': 'Posso sospendere il piano dati attivato se la mia SIM viene persa, rotta o guasta?',
    'faq.question.14': 'E se ho dimenticato la password?',
    'faq.question.15': 'Posso apportare le modifiche dopo che l\'ICCID della mia scheda SIM e il mio ID Lenovo sono stati vincolati?',
    'faq.question.16': 'Cosa devo fare se il dispositivo mi chiede di inserire un codice PIN, PIN 2 o PUK o di inserire un APN?',
    'faq.question.17': 'Come posso controllare l\'ICCID della mia scheda SIM?',
    'faq.question.18': 'CONTACT US',
    'faq.answer.1': 'La scheda SIM supporta solo i dati per l\'accesso alla rete. Non riceverai un numero di cellulare. Puoi comunque effettuare la chiamata o inviare SMS utilizzando app come Skype, WhatsApp.',
    'faq.answer.2': 'Visita aoacwap.lenovoconnect.com per procedere.',
    'faq.answer.3': 'I piani dati ordinati con successo verranno automaticamente attivati (ad es. Espansione del mio piano dati) o attenderanno in coda per essere attivati (ad es. Estensione del mio piano dati). Non supportiamo il rimborso o la sospensione del piano dati.',
    'faq.answer.4': 'Vendiamo i piani in GBP, EUR, USD, CHF, NOK, DKK, SEK e supportiamo carta di credito / bancomat Visa o Master.',
    'faq.answer.5': 'Se desideri smettere di usare la connettività cellulare, fai clic su OFF di "Dati mobili". Tieni presente che il tuo piano dati in corso NON sarà sospeso o rimborsato.',
    'faq.answer.6.1': '1) Se il piano ordinato prevede l\'estensione del tuo piano corrente, può essere attivato solo quando il tuo piano corrente scade.',
    'faq.answer.6.2': '2) Se il piano ordinato prevede di espandere il piano corrente, dovrebbe essere attivato automaticamente. Fai riferimento ad altre domande frequenti per problemi di connettività o contattare l\'Assistenza Clientiil servizio clienti Lenovo.com nel proprio paese.',
    'faq.answer.6.3': '3) Se hai multipli dispositivi con lo stesso ID Lenovo, assicurati che il piano dati ordinato sia sotto l\'ICCID della SIM del dispositivo attualmente utilizzato.',
    'faq.answer.7.1': '1) Verifica se "Dati Mobili" è attivato.',
    'faq.answer.7.2': '2) Verifica se "Roaming Dati" è abilitato. Vai su Impostazioni-> Rete e Internet-> Rete mobile-> Roaming dati',
    'faq.answer.7.3': '3) Verifica che il nome del punto di accesso (APN) sia impostato correttamente. Vai su Impostazioni-> Rete e Internet-> Rete mobile-> Avanzate-> Nomi del punto di accesso-> aggiungi APN: net.truphone.com',
    'faq.answer.7.4': '4) Se questa è la tua prima connessione, potrebbero volerci dei minuti per la connessione della SIM.',
    'faq.answer.7.5': '5) Assicurati che il piano dati precaricato sia attivato; in caso contrario, segui le istruzioni nel pacchetto SIM per attivarlo.',
    'faq.answer.7.6': '6) Assicurati che la tua posizione attuale rientri nel nostro ambito di copertura del servizio (vedi l\'elenco completo dei paesi coperti di seguito). Sposta il tuo dispositivo accanto a una finestra o un\'area aperta per ricevere un segnale migliore.',
    'faq.answer.8': 'Il piano dati può coprire tutti i paesi dell\'UE (Austria, Belgio, Bulgaria, Croazia, Cipro, Repubblica Ceca, Danimarca, Estonia, Finlandia, Francia, Germania, Grecia, Ungheria, Irlanda, Italia, Lettonia, Lituania, Lussemburgo, Malta, Paesi Bassi, Polonia, Portogallo, Romania, Repubblica slovacca, Slovenia, Spagna, Svezia), e Islanda, Norvegia, Svizzera, Regno Unito e Stati Uniti d\'America.',
    'faq.answer.8.1': 'Il piano dati può coprire tutti i paesi dell\'UE (Austria, Belgio, Bulgaria, Croazia, Cipro, Repubblica Ceca, Danimarca, Estonia, Finlandia, Francia, Germania, Grecia, Ungheria, Irlanda, Italia, Lettonia, Lituania, Lussemburgo, Malta, Paesi Bassi, Polonia, Portogallo, Romania, Repubblica slovacca, Slovenia, Spagna, Svezia), e Islanda, Norvegia, Svizzera, Regno Unito.',
    'faq.answer.9': 'Fai riferimento alle informazioni sui contatti di Lenovo.com nel proprio paese.',
    'faq.answer.10': 'La fattura verrà inviata automaticamente al tuo indirizzo email registrato dopo aver ordinato con successo. Controlla la tua casella di posta elettronica e posta indesiderata. Se ancora non viene ricevuta, contatta l\'Assistenza Clienti Lenovo.',
    'faq.answer.11': 'Se la tua scheda SIM è rotta, persa o difettosa, contatta l\'Assistenza Clienti Lenovo per una soluzione.',
    'faq.answer.12': 'Sì, ma potrebbero essere pagati i costi per il servizio di corriere. Contatta l\'Assistenza Clienti Lenovo per i dettagli.',
    'faq.answer.13': 'Scusa, il piano dati non può essere sospeso.',
    'faq.answer.14': 'Puoi reimpostare la password tramite "Password dimenticata" nella pagina di accesso',
    'faq.answer.15': 'Sì. Contatta l\'Assistenza Clienti Lenovo per tale richiesta.Dopo la verifica, lo staff dell\'Assistenza Clienti aiuterà a rimuovere l\'attuale legame tra l\'ICCID della SIM e l\'ID Lenovo. Nota che i piani dati entro validità non possono essere sospesi o rimborsati indipendentemente dallo stato di legame della scheda SIM-ID Lenovo.',
    'faq.answer.16': 'Prova a disattivare e riattivare i "Dati Mobili" e a riavviare il dispositivo. Se il problema persiste, contatta la nostra Assistenza Clienti.',
    'faq.answer.17.1': '1) Puoi trovare l\'ICCID sul chip della SIM o sulla porta della SIM.',
    'faq.answer.17.2': '2) Se hai attivato la SIM e hai precaricato il piano dati, visita aoacwap.lenovoconnect.com e seleziona "Io" -> "Dispositivo"',
    'faq.answer.18': 'Fai riferimento alle informazioni sui contatti di Lenovo.com nel proprio paese.',
}
// 联系我们
const Contact = {
    'contact.chooseRegion.text': 'Seleziona la tua regione',
    'contact.country.AT': 'Austria',
    'contact.country.BE': 'Belgio',
    'contact.country.DK': 'Danimarca',
    'contact.country.FI': 'Finlandia',
    'contact.country.FR': 'Francia',
    'contact.country.DE': 'Germania',
    'contact.country.IE': 'Irlanda',
    'contact.country.IT': 'Italia',
    'contact.country.LUX': 'Lussemburgo',
    'contact.country.NL': 'Paesi Bassi',
    'contact.country.NO': 'Norvegia',
    'contact.country.PT': 'Portogallo',
    'contact.country.ES': 'Spagna',
    'contact.country.SE': 'Svezia',
    'contact.country.CH': 'Svizzera',
    'contact.country.UK': 'Regno Unito',
    'contact.country.USA': 'Stati Uniti',

    'contact.contactus.IT': 'Contatta service@lenovoconnect.com per i dettagli dell’ordine e l\'Assistenza Clienti.',

    'contact.phone.AT': '(+43) (0)1 9287 666',
    'contact.phone.BE': '02-700-73-77 (lokaal tarief)',
    'contact.phone.DK': '+45 89881536',
    'contact.phone.FI': '+358 97 47 90 251',
    'contact.phone.FR': '+ 33 170 381 927',
    'contact.phone.DE': '(+49) (0)201 22099 888',
    'contact.phone.IE': '1-890-928-860 (Le chiamate a questo numero vengono addebitate alla tariffa locale da rete fissa e hanno un costo minimo di € 0,05. Le chiamate da cellulari possono variare.)',
    'contact.phone.IT': '(+39)02 303 10000',
    'contact.phone.LUX': '+352 2487 16 11',
    'contact.phone.NL': '+31 204 990 153',
    'contact.phone.NO': '+47 67 204501',
    'contact.phone.PT': '+351 211 227 833',
    'contact.phone.ES': '+34 9179 11 799',
    'contact.phone.SE': '+46 840 30 01 81',
    'contact.phone.CH': '+41 44 798 2222',
    'contact.phone.UK': '+44 333-777-3991 (Tariffa Nazionale)',
    'contact.phone.USA': '1-800-426-7378, #1',

    'contact.workHours.AT': '9:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.BE': '9:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.DK': '9:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.FI': '9:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.FR': '09:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.DE': '08:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.IE': '09:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.IT': '09:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.LUX': '09:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.NL': '09:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.NO': '09:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.PT': '09:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.ES': '08:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.SE': '09:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.CH': '9:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.UK': '09:00 - 18:00, dal lunedì al venerdì',
    'contact.workHours.USA': '00:00 - 24:00, dal lunedì al domenica',
}
// 绑卡页面
const bindSim = {
    'bindSim.hello': 'Ciao',
    'bindSim.activate.title': 'Attiva il Tuo Piano Dati',
    'bindSim.tip.text1': 'Carica l\'immagine del codice a barre per identificare la scheda SIM',
    'bindSim.tip.text2': 'Attiva e utilizza il piano dati',
    'bindSim.btn.text': 'Carica l\'immagine',
}
//平板faq
const faqApp = {
    'faq.title.1': 'FAQ-About Lenovo Connect',
    'faq.question.1': 'D1: Come posso contattare il Servizio Clienti se nessuno dei seguenti può rispondere alla mia domanda?',
    'faq.answer.1': 'R1: Per informazioni sul Servizio Clienti, contattare il sito ufficiale all\'indirizzo oppure inviare un\'e-mail direttamente a service@lenovoconnect.com. Indicare nell\'e-mail l\'ICCID della scheda SIM.',
    'faq.question.2': 'D2: La scheda SIM supporta le chiamate e gli SMS?',
    'faq.answer.2': 'R2: La scheda SIM supporta solo la funzione Internet del flusso di dati, non la funzione voce o SMS.',
    'faq.question.3': 'D3: La scheda può essere scambiata con altri dispositivi per essere utilizzata?',
    'faq.answer.3': 'R3: È supportato solo per essere inserito nel dispositivo corrente (tavoletta) per l\'uso, non in altri dispositivi per il momento.',
    'faq.question.4': 'D4: In quali paesi è supportato il pacchetto? Ci sono tariffe di roaming nei vari paesi?',
    'faq.answer.4': 'R4: Il pacchetto può essere utilizzato in tutti i Paesi dell\'UE e in Islanda, Norvegia, Svizzera e Regno Unito. Non ci sono costi aggiuntivi di roaming all\'interno di questi Paesi.',
    'faq.title.2': 'FAQ-About Connectivity Service Package',
    'faq.question.5': 'D1: Come posso abbonarmi al pacchetto e controllare la cronologia degli abbonamenti? Il traffico dati del pacchetto può essere accumulato al mese successivo se non viene consumato?',
    'faq.answer.5': 'R1: Visitare l\'App preinstallata "Len" sul desktop dell tavoletta. Oppure visitate il link aoacwap.lenovoconnect.com per verificare il pacchetto di traffico dati sottoscritto. Il pacchetto corrente non può essere accumulato al mese successivo se non viene consumato.',
    'faq.question.6': 'D2: A partire da quale momento si calcola il pacchetto omaggio?',
    'faq.answer.6': 'R2: Registrarsi e accedere all\'App "Len" e cliccare sulla pagina iniziale dopo l\'attivazione del pacchetto per iniziare il conteggio.',
    'faq.question.7': 'D3: Quali sono le regole di abbonamento per i pacchetti?',
    'faq.answer.7': 'R3: Se l\'abbonamento è un nuovo pacchetto, verrà attivato automaticamente.Se l\'abbonamento è un pacchetto overage, verrà attivato una volta esaurito il traffico corrente.I pacchetti non supportano la cancellazione dell\'abbonamento o la sospensione.',
    'faq.question.8': 'D4: Quali sono i metodi di pagamento?',
    'faq.answer.8': 'R4: È supportato il pagamento con Visa o Mastercard (GBP, EUR, USD, CHF, NOK, DKK, SEK).',
    'faq.question.9': "D5: Il pacchetto è stato attivato/sottoscritto con successo, ma non posso utilizzarlo?",
    'faq.answer.9': 'R5: Se l\'abbonamento è per un pacchetto in eccesso, verrà attivato quando il pacchetto esistente sarà esaurito. Se si ha un abbonamento mensile, il pacchetto verrà attivato automaticamente. È possibile controllare lo stato in "I miei ordini". Se non si tratta di uno dei problemi sopra descritti, contattare il servizio clienti Lenovo o direttamente l\'indirizzo service@lenovoconnect.com.',
    'faq.title.3': 'FAQ-About APP Len',
    'faq.question.10': 'D1: Cosa devo fare se l\'App "Len" è stata eliminata per errore o non è stata trovata?',
    'faq.answer.10': `R1: Si prega di consultare il seguente link https://aoacupg.lenovoconnect.com/common/downloadLatest per scaricarlo di nuovo.`,
    'faq.question.11': "D2: Non riesco ad accedere all'App, cosa devo fare?",
    'faq.answer.11.1': 'R2：1. Potrebbe essere necessario molto tempo per accedere all\'App per la prima volta; è possibile attendere circa mezzo minuto.',
    'faq.answer.11.2': '2. Si può provare a uscire completamente dall\'App e a rientrarvi.',
    'faq.answer.11.3': '3. 2. La pagina di registrazione dell\'App mostra: L\'e-mail esiste già. Utilizzare il proprio ID Lenovo per accedere direttamente o registrarsi nuovamente con un nuovo indirizzo e-mail.',
    'faq.answer.11.4': '3. La pagina di login dell\'App mostra che la scheda numerica è già vincolata. In questo caso, la scheda è già stata associata a un account e-mail. Se è necessario disassociare e reimpostare la posta elettronica, inviare un\'e-mail a service@lenovoconnect.com.',
    'faq.question.12': 'D3: Cosa succede se dimentico la password della mia casella di posta elettronica registrata?',
    'faq.answer.12': 'R3：È possibile reimpostare la password facendo clic su "Password dimenticata" in fondo alla pagina di accesso dell\'App "Len".',
    'faq.title.4': 'FAQ-About using data',
    'faq.question.13': "D1: Come faccio a disattivare il traffico se non voglio utilizzarlo?",
    'faq.answer.13': 'R1：Se si desidera disattivare il servizio di traffico Internet, disattivare "Dati mobili" in Impostazioni-Rete&Internet. Una volta disattivata la funzione "Dati mobili", l\'abbonamento non verrà sospeso o annullato.',
    'faq.question.14': 'D2: Non riesco ad accedere a Internet, cosa posso fare?',
    'faq.answer.14.1': 'R2：1. Verificare che l\'interruttore Impostazioni-Rete&Internet-Dati mobili sia attivo.',
    'faq.answer.14.2': '2.Controllare che l\'interruttore Impostazioni-Rete&Internet-Dati in Roaming sia attivo (è necessario che sia attivo, per non incorrere in costi aggiuntivi di roaming).',
    'faq.answer.14.3': '3.Verificare che Impostazioni-Rete&Internet-Avanzate-Nomi dei Punti di Accesso sia impostato correttamente; dovrebbe essere impostato su: lenovo.m2m.drei.at. Se non si dispone di questo APN, inserirlo manualmente.',
    'faq.answer.14.4': '4.Se è la prima volta che ci si connette, potrebbero essere necessari alcuni minuti.',
    'faq.answer.14.5': '5.Accedere all\'App Len e confermare l\'attivazione del pacchetto traffico gratuito cliccando su Attiva.Se non è attivata, accedere all\'App e fare clic su "Attiva" nella pagina principale.',
    'faq.answer.14.6': '6.6.Verificate che la zona rientri nell\'area di servizio(fare riferimento ai paesi sotto indicati per le gamme dettagliate).È possibile spostarsi in un\'area più aperta per ricevere il segnale.(Copre tutti i Paesi dell\'UE: Austria, Belgio, Bulgaria, Croazia, Cipro, Danimarca, Estonia, Finlandia, Francia, Germania, Grecia, Irlanda, Italia, Lettonia, Lituania, Lussemburgo, Malta, Paesi Bassi, Polonia, Portogallo, Romania, Repubblica Slovacca, Slovenia, Spagna, Svezia, Ungheria, oltre a Islanda, Norvegia, Svizzera e Regno Unito).',
    'faq.answer.14.7': '7.Verificare che la scheda SIM sia installata correttamente e riavviare il dispositivo.',
    'faq.answer.14.8': '8.Verificare Impostazioni-Rete&Internet-Selezione Automatica della Rete, è possibile passare/selezionare manualmente una delle reti, nel caso in cui venga visualizzato "vietato" quando viene trovata una rete, fare clic manualmente su di essa e cancellare il "vietato". Cliccate manualmente su di esso e cancellate il "vietato". Se non è possibile selezionare la rete, cambiare la scheda SIM e ripetere la stessa operazione (trovare Dati mobili - Rete e cancellare manualmente la rete vietata).',
    'faq.question.15': "D3: Come si controlla l'ICCID della scheda SIM?",
    'faq.answer.15.1': 'R3：1. Estrarre la scheda SIM inserita nella tavoletta, sulla quale è presente l\'ICCID.',
    'faq.answer.15.2': '2.Controllare in Len-Me-Device dell\'App.',
    'faq.answer.15.3': '3.È possibile visitare il sito aoacwap.lenovoconnect.com e vedere l\'ICCID sulla pagina.',
    'faq.question.16': 'D4:Come posso richiedere una fattura?',
    'faq.answer.16.1': 'R4:Le fatture saranno inviate automaticamente all\'indirizzo e-mail registrato dopo l\'avvenuta sottoscrizione del pacchetto.Controllare la posta in arrivo e la casella di posta indesiderata.Se non viene ancora ricevuto, contattare il servizio clienti o inviare un\'e-mail a service@lenovoconnect.com',
    'faq.title.5': 'FAQ-About SIM Card',
    'faq.question.17': 'D1: Posso cambiare l\'ICCID della mia scheda SIM dopo che è stata associata al mio ID Lenovo?',
    'faq.answer.17': 'R1: Sì, è possibile. Contattare il servizio clienti Lenovo o inviare un\'e-mail a service@lenovoconnect.com per richiedere lo svincolo. Si prega di notare che i pacchetti di abbonamento validi non saranno sospesi a causa del disabbinamento.',
    'faq.question.18': 'D2: Cosa devo fare se non c\'è nessuna scheda nel dispositivo, se la superficie della scheda è visibilmente danneggiata o se la scheda è stata persa? Posso sospendere il pacchetto attivato?',
    'faq.answer.18': 'R2: Se la scheda SIM è rotta o è stata smarrita, contattare il Centro di Assistenza Clienti Lenovo o l\'e-mail di contatto service@lenovoconnect.com per verificare i dettagli e potrà essere inviata una sostituzione. La sospensione o la cancellazione degli abbonamenti attivati non è supportata.',
}
// 接口返回错误码
const iCode = {
    'iCode.i0001': 'Password errata',
    'iCode.i0002': 'La cassetta postale esiste già',
    'iCode.i0003': 'Errore di formattazione della password',
    'iCode.i0004': 'Account deve essere attivato prima del login.',
    'iCode.i0005': 'Account è disabilitato',
    'iCode.i0006': 'Timeout di accesso',
    'iCode.i0007': 'Errata',
    'iCode.i0008': 'Account o password errati',
    'iCode.i0009': 'Inserisci un codice di verifica del grafico a 5 cifre',
    'iCode.i0010': 'Operazione è troppo frequente. Riprova più tardi.',
    'iCode.i0011': 'Indirizzo di callback non valido.',
    'iCode.i0012': 'Firma non valida.',
    'iCode.i0013': 'Aggiorna il codice di verifica',
    'iCode.i0014': 'Errore del Server.',
    'iCode.i0015': 'ID di serviceGoods è vuoto',
    'iCode.i0016': 'Invio del messaggio risuscito',
    'iCode.i0017': 'Invio del messaggio non riuscito',
    'iCode.i0018': 'Errore del codice di riscatto',
    'iCode.i0019': 'Utilizza entro il periodo di riscatto',
    'iCode.i0020': 'Codice di riscatto scaduto',
    'iCode.i0021': 'Codice di riscatto è stato utilizzato',
    'iCode.i0022': 'Codice di riscatto non è più valido',
    'iCode.i0023': 'L\'ordine è in corso di creazione, attendi ...',
    'iCode.i0024': 'Operazione non riuscita',
    'iCode.i0025': 'La carta non soddisfa i requisiti di riscatto',
    'iCode.i0026': 'Generazione del codice QR non riuscita',
    'iCode.i0027': 'Informazioni errate sulla creazione dell\'ordine di aggiornamento',
    'iCode.i0028': 'La scheda SIM non esiste',
    'iCode.i0029': 'Errore nel formato del numero di cellulare',
    'iCode.i0030': 'SMS inviato troppo spesso',
    'iCode.i0031': 'Errore di parametro',
    'iCode.i0032': 'Il numero di invio del codice di verifica in un giorno ha raggiunto il limite massimo',
    'iCode.i0033': 'Registrazione riuscita',
    'iCode.i0034': 'Registrazione dell\'account non riuscita',
    'iCode.i0035': 'Prima vincola l\'ICCID della SIM',
    'iCode.i0036': 'Prima accedi all\'account',
    'iCode.i0037': 'Aggiornamento dello stato non riuscito',
    'iCode.i0038': 'Attivato, attendi',
    'iCode.i0039': 'Order ID è vuoto',
    'iCode.i0040': 'Attivazione in corso, attendi',
    'iCode.i0041': 'Il piano dati è fuori commercio',
    'iCode.i0042': 'Attivazione non riuscita!',
    'iCode.i0043': 'Attivazione risuscita!',
    'iCode.i0044': 'Il sistema non è in grado di identificare la SIM',
    'iCode.i0045': 'piano attivato, non ripeti',
    'iCode.i0046': 'Nessun piano attivato',
    'iCode.i0047': 'SIM interrotta',
    'iCode.i0048': 'Informazioni del piano errate',
    'iCode.i0049': 'L\'utente o la password è vuota',
    'iCode.i0050': 'Nessun piano base per il mese',
    'iCode.i0051': 'Accesso risuscito',
    'iCode.i0052': 'Accesso non riuscito',
    'iCode.i0053': 'Il dispositivo è vuoto',
    'iCode.i0054': 'Errore del codice di verifica, reinseriscilo',
    'iCode.i0055': 'Operazione risuscita',
    'iCode.i0056': 'la scheda è vuota',
    'iCode.i0057': 'Acquisizione del token non riuscita',
    'iCode.i0058': 'Codice aziendale inesistente',
    'iCode.i0059': 'L\'uso della SIM è incoerente con le proprietà dell\'azienda',
    'iCode.i0060': 'Non operare frequentemente',
    'iCode.i0061': 'Ricevuto coupon con successo',
    'iCode.i0062': 'Condizioni non soddisfatte',
    'iCode.i0063': 'Errore nel ricevimento del coupon',
    'iCode.i0064': 'Vincolo di Iccid non riuscito',
    'iCode.i0065': 'La scheda è vincolata da un altro conto',
    'iCode.i0066': 'Vincolo risuscito',
    'iCode.i0067': 'Errore di vincolo',
    'iCode.i0068': 'L\'ID della SIM è vuoto',
    'iCode.i0069': 'esimId è vuoto',
    'iCode.i0070': 'Nessuna SIM vincolata',
    'iCode.i0071': 'L\'utente non esiste',
    'iCode.i0072': 'Soprannome non può essere vuoto',
    'iCode.i0073': 'Aggiornamento risuscito',
    'iCode.i0074': 'Aggiornamento non riuscito',
    'iCode.i0075': 'Home page nessuna SIM, richiesta anomala del piano',
    'iCode.i0076': 'Informazioni rilevanti non disponibili',
    'iCode.i0077': 'Generazione della firma crittografata non riuscita.',
    'iCode.i0078': 'Cambio non riuscito',
    'iCode.i0079': 'Cambio risuscito',
    'iCode.i0080': 'Non inviare le richieste ripetutamente!',
    'iCode.i0081': 'Aggiorna e prova di nuovo!',
    'iCode.i0082': 'Acquisizione del grafico del banner della homepage non riuscita',
    'iCode.i0083': 'Attualmente nessun ICCID vincolato, nessun piano preferenziale',
    'iCode.i0084': 'Attualmente nessun ICCID vincolato, nessun piano disponibile',
    'iCode.i0085': 'Autenticazione riuscita',
    'iCode.i0086': 'Autenticazione fallita',
    'iCode.i0087': 'Eccezione di sistema',
    'iCode.i0088': '卡已实名',
    'iCode.i0089': 'Il piano è stato ordinato con successo',
    'iCode.i0090': 'Ordine del piano non riuscito',
    'iCode.i0091': 'L\'articolo di servizio non esiste',
    'iCode.i0092': 'Generazione dell\'ordine di aggiornamento completata',
    'iCode.i0093': 'Nessun servizio di aggiornamento del piano disponibile',
    'iCode.i0094': 'Nessun ordine corrispondente trovato',
    'iCode.i0095': 'Il piano attuale non è pagato',
    'iCode.i0096': 'L\'ID del piano è vuoto nell\'ordine',
    'iCode.i0097': 'Il piano è abilitato',
    'iCode.i0098': 'Ordine risuscito',
    'iCode.i0099': 'Nessun codice disponibile ora',
    'iCode.i0100': 'Nessun codice disponibile per quest\'area',
    'iCode.i0104': 'Impossibile ottenere la sottoregione della scheda SIM',
    'iCode.i0109': 'Lettura del codice a barre non riuscita, riprova.',
}
export default {
    ...common,
    ...language,
    ...login,
    ...home,
    ...packageDetail,
    ...register,
    ...packageCard,
    ...billAddress,
    ...me,
    ...accountInfo,
    ...order,
    ...device,
    ...myDataPlan,
    ...FAQ,
    ...iCode,
    ...payResult,
    ...Contact,
    ...bindSim,
    ...suggest,
    ...faqApp,
    'tab.text.home': 'Homepage',
    'tab.text.me': 'Mio'
}
